import React, {useEffect} from "react";
import {bindActionCreators} from "redux";
import customerActionsImp from "../../../Actions/customerActions";
import {useDispatch, useSelector} from "react-redux";
import {VonCreateForm} from "../../../Utils/customerFormUtils";
import {CustomerForm} from "./CustomerForm";

export const CreateSaasCustomerForm = ({}) => {
    const dispatch = useDispatch();
    const customer = useSelector((state) => state.CustomerReducer.customer);
    const customerActions = bindActionCreators(customerActionsImp, dispatch);
    const form = useSelector((state) => state.FormReducer.forms.customerFormData);
    
    useEffect(() => {
        if (!form) {
            customerActions.getSelectedCustomerForEdit(customer.vbCustomer?.customerNumber);
        }
    }, []);
    
    if (!form) {
        return null;
    }
    return <CustomerForm
        columns={VonCreateForm()}
        form={form}
    />
}